import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const calculator = document.getElementById('electricity-calculator');

if (calculator) {
  const locale = calculator.dataset.lang === 'es' ? 'es' : 'en';
  const root = ReactDOM.createRoot(calculator);

  root.render(
    <React.StrictMode>
      <App locale={locale} />
    </React.StrictMode>
  );

  reportWebVitals();
}
